/**
 * The API-keys panel.
 *
 * The values are stored in this browser's localStorage only, and are sent
 * only to Google. Saving reloads: the library client, the account chip and
 * the sheet all read the credentials at startup.
 */

import { type Component, createSignal } from 'solid-js';
import { clearCreds, saveCreds } from '../../config/storage.ts';
import { creds } from '../../state/library.ts';
import { Button, Field, Hint } from './Controls.tsx';

export const ApiKeys: Component = () => {
  const [clientId, setClientId] = createSignal(creds().GOOGLE_CLIENT_ID);
  const [apiKey, setApiKey] = createSignal(creds().YOUTUBE_API_KEY);

  const save = (): void => {
    saveCreds({
      GOOGLE_CLIENT_ID: clientId().trim(),
      YOUTUBE_API_KEY: apiKey().trim(),
    });
    location.reload();
  };

  const clear = (): void => {
    clearCreds();
    location.reload();
  };

  return (
    <>
      <p>
        Paste the two values from Google Cloud Console. They are stored only in this browser and are
        sent only to Google.
      </p>

      <h3>OAuth client ID</h3>
      <Field
        id="in-client"
        placeholder="1234567890-abcdef.apps.googleusercontent.com"
        value={clientId()}
        onInput={setClientId}
      />
      <Hint>
        Google Cloud Console → APIs &amp; Services → Credentials → Create OAuth client ID → Web
        application. Add <code>{location.origin}</code> to “Authorised JavaScript origins”.
      </Hint>

      <h3>API key (optional)</h3>
      <Field id="in-key" placeholder="AIzaSy…" value={apiKey()} onInput={setApiKey} />
      <Hint>Lets search work before you sign in. Restrict it to the YouTube Data API v3.</Hint>

      <Button onClick={save}>Save and reload</Button>
      <Button variant="quiet" onClick={clear}>
        Clear saved keys
      </Button>
    </>
  );
};
